module.exports = __webpack_public_path__ + "media/PackLabel_IN.99e56783.mp4";